import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUserInfo from 'src/hooks/useUserInfo';
import { DEFAULT_CALLBACK_URL_SIGNED_IN } from 'src/misc/Config';
import SignIn from 'src/components/controls/SignIn/SignIn';
import DarkModeSwitch from 'src/components/layout/DarkModeSwitch';

//import PropTypes from 'prop-types';

const SignInPage = () => {
  const navigate = useNavigate();
  const userInfo = useUserInfo();

  useEffect(() => {
    if (userInfo) {
      navigate(DEFAULT_CALLBACK_URL_SIGNED_IN);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <>
      <div className='absolute top-4 right-4 z-10'>
        <DarkModeSwitch />
      </div>
      <div className='relative w-full h-[100vh] flex flex-col items-center justify-center'>
        <SignIn />
      </div>
    </>
  );
};

SignInPage.propTypes = {};

export default SignInPage;
